import {
    API_DOMAIN_AUTH_CONFIG,
    API_DOMAIN_VIKON_CONFIG,
    CLIENT_ID_CONFIG,
    VUZ_ID_CONFIG,
    API_DOMAIN_FILEMANAGER_CONFIG,
    VUZ_NAME_CONFIG,
} from '../store/actionTypes';

export const clientId = (state = 0, action) => {
    switch (action.type) {
        case CLIENT_ID_CONFIG:
            return action.id;
        default:
            return state;
    }
};
export const vuzId = (state = 0, action) => {
    switch (action.type) {
        case VUZ_ID_CONFIG:
            return action.id;
        default:
            return state;
    }
};
export const apiDomainAuth = (state = '', action) => {
    switch (action.type) {
        case API_DOMAIN_AUTH_CONFIG:
            return action.url;
        default:
            return state;
    }
};
export const apiDomainVikon = (state = '', action) => {
    switch (action.type) {
        case API_DOMAIN_VIKON_CONFIG:
            return action.url;
        default:
            return state;
    }
};
export const apiDomainFilemanager = (state = '', action) => {
    switch (action.type) {
        case API_DOMAIN_FILEMANAGER_CONFIG:
            return action.url;
        default:
            return state;
    }
};
export const vuzName = (state = '', action) => {
    switch (action.type) {
        case VUZ_NAME_CONFIG:
            return action.value;
        default:
            return state;
    }
};
